// Query-key factory for GET /api/v1/tenants/me/customization. Distinct from
// tenantKeys (org settings) so saving branding doesn't churn the settings cache.
export const customizationKeys = {
  all: ['customization'] as const,
  current: () => [...customizationKeys.all, 'current'] as const,
};
